{
  "MaxPartitions": "Only the first {} partitions will be checked for devices, please enable \"Telephony-Wide Reporting\" in the Telsys settings to check all partitions.",
  "Error_Title": "Sorry",
  "Error_SubTitle": "We cannot find the page you are looking for.",
  "Error_Message": "The page or resource may have been moved, updated or deleted.\n\nOr you may have typed the web address incorrectly. Please check the address and spelling.",
  "Error_PageTitle": "Sorry, we cannot find the page you are looking for.",
  "NAME": "ErrorLanguage"
}